<template>
  <div class="home">
    <l-header />
    <!-- 一般使用 -->
    <first-view />
    <!-- 活動用 -->
    <!-- <first-view-as-campaign /> -->
    <statstics />
    <media />
    <news />
    <good-take-care />
    <gift />
    <learn-more />
    <l-footer />
    <declare />
    <top />

    <pr-dialog v-model:visible="dialogVisible.antiFraudAlert" appendToBody>
      <anti-fraud-alert @closeDialog="closeDialog" />
    </pr-dialog>

  </div>
</template>

<script>
import { reactive } from 'vue';
import FirstView from '@/views/Base/Home/FirstView.vue';
// import FirstViewAsCampaign from '@/views/Base/Home/FirstViewAsCampaign.vue';
import Statstics from '@/views/Base/Home/Statistics.vue';
import Media from '@/views/Base/Home/Media.vue';
import News from '@/views/Base/Home/News.vue';
import GoodTakeCare from '@/views/Base/Home/GoodTakeCare.vue';
import Gift from '@/views/Base/Home/Gift.vue';
import LearnMore from '@/views/Base/Home/LearnMore.vue';
import Top from '@/views/Base/Home/Top.vue';
import LHeader from '@/layout/Header.vue';
import LFooter from '@/layout/Footer/index.vue';
import Declare from '@/layout/Footer/Declare.vue';
import useMeta from '@/hooks/useMeta';
import PrDialog from '@/components/Global/Dialog.vue';
import AntiFraudAlert from '@/components/Dialog/AntiFraudAlert.vue';

export default {
  name: 'Home',
  components: {
    FirstView,
    // FirstViewAsCampaign,
    Statstics,
    Media,
    News,
    GoodTakeCare,
    Gift,
    LearnMore,
    LHeader,
    LFooter,
    Declare,
    Top,
    PrDialog,
    AntiFraudAlert,
  },
  setup() {
    const { metaRequset } = useMeta();

    const dialogVisible = reactive({
      antiFraudAlert: false,
    });

    const openDialog = (type) => {
      dialogVisible[type] = true;
    };

    const closeDialog = (type) => {
      dialogVisible[type] = false;
    };

    metaRequset();

    openDialog('antiFraudAlert');

    return {
      dialogVisible,
      openDialog,
      closeDialog,
    };
  },
};
</script>

<style lang="scss"></style>
